
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from '../../../../config/config';


const handleSubmit = async (event, formData, redirectCallback) => {

  event.preventDefault();
  try {

    const token = localStorage.getItem('token');
    if (!token || token == "null") {
      redirectCallback();
      return; // Return early to prevent further execution
    }
    const CompanyID = localStorage.getItem("CompanyID");
    formData.ClientID = CompanyID;
    const UserID = localStorage.getItem("UserID");
    formData.UserID = UserID;
    const response = await axiosInstance.post(`/Setup/CreateImportTable`, formData);
 
    return response.data;
  } catch (error) {
    console.error('Error posting data:', error);
    return error;
  }

};

export { handleSubmit };